'use strict';
import reqwest from 'reqwest';
import store from 'store';

var accessToken = null;
var runningRequests = {}; // URL => Request

export default {
    cachedImagePath(imageUrl, width=650) {
        return imageUrl; //'https://images.msnode.de/display?url=' + imageUrl + '&w=' + width + '&h=0&op=resize&upscale=0';
    },
    removeToken() {
        accessToken = null;
    },
    registerToken(token) {
        accessToken = token;
    },
    getHtml(url) {
        return reqwest({
            url: url,
            method: 'get'
        });
    },
    getLocale(locale) {
        // loca the local from local
        if (!!locale) {
            return this.get('language/' + locale, {});
        } else {
            return this.get('language', {});
        }
    },
    getNoAuth(url, params) {
        return reqwest({
            url: window.config.baseUrl + '/' + url,
            data: params,
            type: 'json',
            method: 'get',
        });
    },
    get(url, params) {
        if (runningRequests[url] !== undefined) {
            try {
                runningRequests[url].abort();
            } catch(ex) {
                // Ignore Exceptions on Abort
            }
            console.log("Called abort");
        }
        var request = reqwest({
            url: window.config.baseUrl + '/' + url,
            data: params,
            type: 'json',
            method: 'get',
            headers: {
                'Authorization': accessToken
            },
            complete: function(resp) {
                console.log("Calling Complete");
                delete runningRequests[url]
            }
        });
        console.log("Created new Request");
        runningRequests[url] = request;
        return request;
    },
    post(url, params, success, error) {
        return reqwest({
            url: window.config.baseUrl + '/' + url,
            data: JSON.stringify(params),
            type: 'json',
            method: 'post',
            contentType: 'application/json',
            headers: {
                'Authorization': accessToken,
                'X-CSRF-Token': store.get('_CSRF')
            },
            success: success,
            error: error
        });
    },
    upload(url, formData, success, error) {
        return reqwest({
            url: window.config.baseUrl + '/' + url,
            data: formData,
            type: 'json',
            method: 'post',
            processData: false,
            contentType: 'multipart/form-data',
            headers: {
                'Authorization': accessToken,
                'X-CSRF-Token': store.get('_CSRF')
            },
            success: success,
            error: error
        });
    }
};



// WEBPACK FOOTER //
// ./app/utils/api.js